import React from 'react';

export class ThreeState extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.data =
            [{ id: 1, name: "بله" }, { id: 2, name: "خیر" }];


        this.handleChange = this.handleChange.bind(this);

    }
    handleChange(e) {
        var val = null;

        console.log(e.target.value);

        if (e.target.value == -1)
            val = null;
        else
            if (e.target.value == 1)
                val = true;
            else
                if (e.target.value == 2)
                    val = false;


        if (typeof this.props.onChange === "function")
            this.props.onChange(val, this.props.name);

    }

    componentDidMount() {

        this.state.selected = this.props.Selected;

    }

    render() {


        var divStyleOp = {

            dir: 'rtl',
            'textAlign': 'center'

        };


        console.log(this.props.Selected);

        if (this.props.Selected === null)

            this.selected = -1;

        if (this.props.Selected === true)

            this.selected = 1;

        if (this.props.Selected === false)

            this.selected = 2;

        //   console.log(this.props.Data);
        if (this.data != null) {
            var options = this.data.map((data) =>
                <option style={divStyleOp} key={data.id} value={data.id}>{data.name}</option>
            );
        }
        else {
            var options = "";
        }

        var emptyOption = null;
        if (this.props.showEmptyOption === false) {

        }
        else {
            var emptyOption = <option style={divStyleOp} key={-1} value={-1}>انتخاب کنید</option>;
        }

        console.log();

        return (

            <div class="input-group" style={{ width: "100%" }}>
                <div class="input-group-prepend" style={{ width: "30%" }}>
                    <span class="input-group-text" style={{ width: "100%" }}>{this.props.label}</span>
                </div>
                <select

                    className="custom-select"
                    value={this.selected}

                    ref="myRef"
                    required={this.props.required}
                    onChange={this.handleChange}>
                    {emptyOption}
                    {options}
                </select>

            </div>

        );
    }
}



// WEBPACK FOOTER //
// ./src/elements/ThreeState.js